// extracted by mini-css-extract-plugin
export var assigneeBadge = "_n2-0";
export var assigneeDetails = "_n2-1";
export var assigneeInfo = "_n2-2";
export var dropdownContainer = "_n2-4";
export var dropdownImage = "_n2-5";
export var editAssigneeInfo = "_n2-3";
export var editAssigneeModalContainer = "_n2-6";
export var hidden = "_n2-8";
export var input = "_n2-7";